import React from 'react'
import { Box, Button, Heading, Text } from 'grommet'

const PageEventMain = () => {
    return(
        <Box>
            <Text>PageEventMain</Text>
        </Box>
    )
}

export default PageEventMain

